import uniq from 'lodash/uniq';

import { CompatibilityMap } from './types';

export const buildAllInstances = (map: CompatibilityMap): Set<string> =>
  new Set(
    Array.from(map.values()).flatMap((innerMap) =>
      Array.from(innerMap.values()).flatMap((values) => values)
    )
  );

export const getCompatibleCount = (
  instance: string,
  map: CompatibilityMap,
  availableInstances: string[]
): number => {
  const available = new Set(availableInstances);
  for (const innerMap of map.values()) {
    for (const instances of innerMap.values()) {
      if (instances.includes(instance)) {
        return instances.filter((i) => available.has(i)).length;
      }
    }
  }
  return 0;
};

export const getCompatibleInstances = ({
  instance,
  compatibilityMap,
}: {
  instance: string;
  compatibilityMap: CompatibilityMap;
}): string[] => {
  const familiesPerSet = Array.from(compatibilityMap.values()).map(
    (familiesByCpuGroup) => Array.from(familiesByCpuGroup.values()).flat()
  );

  const compatibleFamilies = familiesPerSet
    .filter((families) => families.includes(instance))
    .flat()
    .filter((candidateInstance) => candidateInstance !== instance);

  return uniq(compatibleFamilies);
};
